import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation, useQuery } from "react-query";
import { QueryKeys } from "../queryKeys";

export type GetCommissionListByIdRequest = {
  id: number | string;
};

export type GetCommisssionListByIdResponse = any;

async function getCommissionList(data: GetCommissionListByIdRequest): Promise<any> {
  try {
    const id1 = data.id;
    return (await axiosInstance.get(`/CommissionParameter/ListByMerchantId?id=${id1}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetCommissionListByMerchantId() {
  return useMutation<any, Error, GetCommissionListByIdRequest>((variables) =>
    getCommissionList(variables)
  );
}
